import { DELETE_SCHEDULE, SET_PATH } from '../actions/types';
import { DateStringMMDDYYYY } from '../actions/types';
import { debugLog } from '../Util';

const websocketMiddleware = () => {
  return store => next => action => {
    // Change path to latest project schedule if the one currently being viewed is being deleted
    //if(action.type === DELETE_SCHEDULE) {
    //  try {
    //    const schedulePath = 'projectId#' + action.payload.project.id + '#scheduleId#' + action.payload.scheduleId;
    //    if(store.getState().localPersistent.path !== schedulePath) throw new Error(''); // we're not viewing the schedule that was deleted
    //    
    //    const sortedSchedules = [];
    //    const scheduleProject = store.getState().serverSynced.projects[action.payload.project.id];
    //    if(scheduleProject === undefined) throw new Error('');

    //    for(const key in scheduleProject.schedules) {
    //      if(key !== action.payload.scheduleId) {
    //        sortedSchedules.push({ id: key, beginDate: scheduleProject.schedules[key] });
    //      }
    //    }
    //    if(sortedSchedules.length === 0) {
    //      const setPathAction = {
    //        type: SET_PATH,
    //        payload: 'projectId#' + scheduleProject.id + '#schedule',
    //      };
    //      debugLog('reducer: ', setPathAction);
    //      next(setPathAction);
    //    } else {
    //      sortedSchedules.sort((one, two) => {
    //        try {
    //          const oneDate = DateStringMMDDYYYY.toDateObject(one.beginDate);
    //          const twoDate = DateStringMMDDYYYY.toDateObject(two.beginDate);
    //          return twoDate.getTime() - oneDate.getTime();
    //        } catch(error) {
    //          return 0;
    //        }
    //      });
    //      const setPathAction = {
    //        type: SET_PATH,
    //        payload: 'projectId#' + scheduleProject.id + '#scheduleId#' + sortedSchedules[0].id,
    //      };
    //      debugLog('reducer: ', setPathAction);
    //      next(setPathAction);
    //    }
    //  } catch(error) {}
    //}

    debugLog('reducer: ', action);
    next(action);
  };
};

export default websocketMiddleware();
